import PropTypes from 'prop-types';

import styles from './ExceptionLayout.module.scss';

const ExceptionLayout = ({ children }) => (
  <section className={styles.exceptionLayout}>{children}</section>
);

ExceptionLayout.propTypes = {
  children: PropTypes.node,
};

ExceptionLayout.defaultProps = {
  children: <div />,
};

export default ExceptionLayout;
